"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "medolago": {
    "1c545d91": [{
      "hkey": "faeb099d",
      "slug": "medolago",
      "name": "Medolago",
      "primary": true,
      "skipSearch": false
    }],
    "adda": [{
      "hkey": "faeb099d",
      "slug": "medolago",
      "name": "Medolago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d33cd665": [{
      "hkey": "faeb099d",
      "slug": "medolago",
      "name": "Medolago",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-grandone": [{
      "hkey": "faeb099d",
      "slug": "medolago",
      "name": "Medolago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ff832f7b": [{
      "hkey": "faeb099d",
      "slug": "medolago",
      "name": "Medolago",
      "primary": true,
      "skipSearch": false
    }],
    "san-protasio": [{
      "hkey": "faeb099d",
      "slug": "medolago",
      "name": "Medolago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d0c6c72c": [{
      "hkey": "faeb099d",
      "slug": "medolago",
      "name": "Medolago",
      "primary": true,
      "skipSearch": false
    }],
    "torre": [{
      "hkey": "faeb099d",
      "slug": "medolago",
      "name": "Medolago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;